import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { ComentariosService } from '../../services/comentarios.service';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { isNil } from 'lodash';
import { ProfessorModel } from '../../models/professor.model';
import { NgxHotjarService } from 'ngx-hotjar';
@Component({
  selector: 'app-comentarios',
  templateUrl: './comentarios.component.html',
  styleUrls: ['./comentarios.component.scss'],
})
export class ComentariosComponent {
  constructor(
    private comentarioService: ComentariosService,
    public loaderService: LoaderService,
    private hotjar: NgxHotjarService,
  ) { }

  _tokenAcesso: string;
  @Input()
  set tokenAcesso(value: string) {
    this._tokenAcesso = value;
    this.Initialize();
  }
  get tokenAcesso(): string {
    return this._tokenAcesso;
  }

  comentario: { observacoes: string } = { observacoes: '' };

  salvo = false;

  comentariosend = true;

  statusComentario = false;

  @Input()
  quantidadeProfessores: number;


  Initialize(): void {
    this.salvo = false;

    if (!this.tokenAcesso) {
      this.comentario = { observacoes: '' };
      return;
    }

    this.loaderService.show();
    this.comentarioService.getPOAComentario(this.tokenAcesso).subscribe(
      x => {
        this.comentario = x;
        this.loaderService.hide();
        this.statusComentario = x.statusObservacao;
      },
      () => this.loaderService.hide()
    );
  }




  change(x: string = "") {
    this.comentario.observacoes = x;
    this.salvo = false;

    if(x.length)
      this.comentariosend = false;
    else
      this.comentariosend = true;
  }

  salvar() {
    if (this.comentario.observacoes.length && this.salvo == false) {
      if (!isNil(this.comentario)) {
        this.comentariosend = true;
        this.loaderService.show();

        this.comentarioService
          .salvarObservacaoComentario(this.tokenAcesso, this.comentario)
          .subscribe(
            () => {
              this.salvo = true;
              this.comentariosend = true;
              this.loaderService.hide();
              this.statusComentario = true;

              this.hotjar.trigger("questionario_poa__questionario__pesquisa_comentada")
            },
            () => {
              this.comentariosend = false;
              this.loaderService.hide();
            }
          );
      }
    }
  }

}
